import deCustomer from './de/customer.json';
import frCustomer from './fr/customer.json';

export default {
  de: {
    customer: deCustomer,
  },
  fr: {
    customer: deCustomer,
  },
};
